import { motion } from 'framer-motion'
import ScrollReveal from '../shared/ScrollReveal'
import AnimatedCounter from '../shared/AnimatedCounter'
import './StatsSection.css'

const stats = [
  { value: 156, label: 'Screens across web + mobile', suffix: '' },
  { value: 83, label: 'Distinct portal views', suffix: '' },
  { value: 310, label: 'UI building blocks', suffix: '+' },
  { value: 100, label: 'Visualization components', suffix: '' }
]

const secondaryStats = [
  { value: 5, label: 'ML Models', desc: 'One intelligence' },
  { value: 16, label: 'Fault Categories', desc: 'XGBoost classified' },
  { value: 3, label: 'Integration Layers', desc: 'Land · Air · Space' },
  { value: 10, suffix: '+', label: 'Languages', desc: 'EN · DE · ES · FR · IT · NL · PL · PT · RO · EL' }
]

export default function StatsSection() {
  return (
    <section className="stats-section">
      <div className="container">
        <ScrollReveal className="stats-header">
          <span className="stats-eyebrow">// BUILT TO SCALE</span>
          <h2 className="stats-title">Engineered for depth.</h2>
        </ScrollReveal>

        {/* Primary stats */}
        <div className="stats-primary">
          {stats.map((stat, i) => (
            <ScrollReveal key={i} delay={i * 0.1} className="stat-item-primary">
              <motion.div
                className="stat-card-primary"
                whileHover={{ y: -5, boxShadow: '0 20px 40px rgba(255, 215, 0, 0.1)' }}
              >
                <AnimatedCounter
                  value={stat.value}
                  suffix={stat.suffix}
                  className="stat-number-primary"
                />
                <span className="stat-label-primary">{stat.label}</span>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>

        {/* Secondary stats */}
        <div className="stats-secondary">
          {secondaryStats.map((stat, i) => (
            <ScrollReveal key={i} delay={0.4 + i * 0.1}>
              <motion.div
                className="stat-card-secondary"
                whileHover={{ scale: 1.02 }}
              >
                <div className="stat-number-secondary">
                  <AnimatedCounter value={stat.value} suffix={stat.suffix || ''} />
                </div>
                <div className="stat-info-secondary">
                  <span className="stat-label-secondary">{stat.label}</span>
                  <span className="stat-desc-secondary">{stat.desc}</span>
                </div>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}
